import React from 'react';
import { BookOutlined, LinkOutlined, PlayCircleOutlined } from '@ant-design/icons';

// Info-link titles (Wikipedia, Trailer, ...) come from the API and aren't a
// fixed enum (editors occasionally add a one-off article link) — match the
// common ones by keyword and fall back to a generic link icon rather than
// trying to enumerate every possible title.
export const linkIcon = (title = '') => {
    const lower = title.toLowerCase();
    if (lower.includes('wiki')) return <BookOutlined />;
    if (lower.includes('trailer')) return <PlayCircleOutlined />;
    return <LinkOutlined />;
};
